import { useState } from "preact/hooks";
import { useTranslation, Trans } from "react-i18next";
import { Navigation } from "../../components";
import { useModal } from "../../shared/contexts";
import { PageContainer, Typography } from "../../shared/ui";
import { ModalChildrenProps } from "../../shared/ui/Modal/Modal";
import { generateAssetLink } from "../../shared/utils/generateAssetLink";
import css from "./Onboarding.module.scss";

export const Onboarding = ({ onClose }: ModalChildrenProps) => {
  const { t } = useTranslation();
  const slides = [
    {
      id: 1,
      image: "1.webp",
      title: t("onboarding.place_bet"),
      subtitle: t("onboarding.climb_begins"),
      description: t("onboarding.get_ready"),
      titleColor: "multiplayer-orange",
      buttonText: t("onboarding.next"),
      buttonColor: "#8B5CF6",
    },
    {
      id: 2,
      image: "2.webp",
      title: t("onboarding.climb_higher"),
      subtitle: t("onboarding.win_bigger"),
      description: t("onboarding.cash_out_multiplier"),
      titleColor: "green",
      buttonText: t("onboarding.next"),
      buttonColor: "#8B5CF6",
    },
    {
      id: 3,
      image: "3.webp",
      title: t("onboarding.cash_out"),
      subtitle: t("onboarding.before_jester_slips"),
      description: t("onboarding.make_it_manually"),
      titleColor: "blue",
      buttonText: t("onboarding.next"),
      buttonColor: "#8B5CF6",
    },
    {
      id: 4,
      image: "4.webp",
      title: t("onboarding.lose_bet_gain_point"),
      subtitle: "",
      description: t("onboarding.free_bonus_bet"),
      titleColor: "blue",
      buttonText: t("onboarding.get_started"),
      buttonColor: "#06B6D4",
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const { openModal } = useModal();
  const handleClose = () => {
    setCurrentSlide(0);
    onClose();
  };
  const handleNext = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      handleClose();
    }
  };

  const currentSlideData = slides[currentSlide];

  return (
    <div
      className={css.onboardingContainer}
      data-onboarding
      style={{
        backgroundImage: `url(${generateAssetLink(`onb-${currentSlideData.image}`)})`,
      }}
    >
      <Navigation title={t("onboarding.title").toUpperCase()} />
      <PageContainer className={css.content}>
        <div className={css.textContainer}>
          <Typography variant="h1" color={currentSlideData.titleColor}>
            {currentSlideData.title.toUpperCase()}
          </Typography>
          <Typography variant="h1" color={currentSlideData.titleColor}>
            {currentSlideData.subtitle.toUpperCase()}
          </Typography>
          <Typography variant="caption2" color="header-small">
            {currentSlideData.description}
          </Typography>
        </div>
        <div className={css.buttonsContainer}>
          <div className={css.indicators}>
            {slides.map((_, index) => (
              <div
                key={index}
                className={`${css.indicator} ${index === currentSlide ? css.active : ""}`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>

          <button
            className={css.nextButton}
            style={{ backgroundColor: currentSlideData.buttonColor }}
            onClick={handleNext}
          >
            <Typography
              variant="button1"
              color={currentSlideData.id === 4 ? "black" : "white"}
            >
              {currentSlideData.buttonText}
            </Typography>
          </button>

          {/* <button
            className={css.provablyFairButton}
            onClick={() => {
              openModal("ProvablyFairDescription");
            }}
          >
            <Typography className={css.btnText} color="orange">
              What is Provably Fair
            </Typography>
          </button> */}
          <button
            className={css.btn}
            onClick={() => {
              openModal("gameRules");
            }}
          >
            <Typography variant="h2" color="light-grey">
              <Trans
                i18nKey="onboarding.read_rules"
                components={{ h: <span /> }}
              />
            </Typography>
          </button>
        </div>
      </PageContainer>
    </div>
  );
};
